<template>
  <div id="app">
    <input type="text" class="f-text" v-model="num1" @keyup="handleNum1">
    <strong>vs</strong>
    <input type="text" class="f-text" v-model="num2" @keyup="handleNum2">
    <input @click="handleBignum" type="button" value="最大的数是 &raquo;" class="f-btn"><span>{{which}}</span>
  </div>
</template>
<script>
export default {
  data:function(){
    return{
      num1:'',
      num2:'',
      which:'?'
    }
  },
  methods:{
    handleNum1(){
      this.num1=this.num1.replace(/[^\d]/,'');
    },
    handleNum2(){
      this.num2=this.num2.replace(/[^\d]/,'');
    },
    handleBignum(){
      (this.num1=='' || this.num2=='') ?
      alert('请输入数字!') :
      this.which=Math.max(this.num1,this.num2);
    }
  }
}
</script>
<style>
body{
  font: 12px/1.5 arial;
  text-align: center;
}
.f-text{
  width: 50px;
  border: 1px solid #ccc;
  background: #f0f0f0;
  font-family: inherit;
  padding: 3px;
}
.f-btn{
  margin: 0 10px;
}
strong{
  padding: 0 10px;
}
span{
  font-weight: 700;
  color: red;
}
</style>
